var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-page"},[_c('div',{staticClass:"title-box",style:([
        {'textAlign':_vm.configData.textPosition.list[_vm.configData.textPosition.type].style},
        {'fontStyle': _vm.configData.textStyle.list[_vm.configData.textStyle.type].style !='bold' ? _vm.configData.textStyle.list[_vm.configData.textStyle.type].style:''},
        {'fontWeight':_vm.configData.textStyle.list[_vm.configData.textStyle.type].style  =='bold' ? _vm.configData.textStyle.list[_vm.configData.textStyle.type].style:''},
        {'fontSize':_vm.configData.fontSize.val+'px'},
        {'marginTop':_vm.configData.mbConfig.val+'px'},
        {'background':_vm.configData.bgColor.color[0].item},
        {'margin':'0 '+ _vm.configData.prConfig.val + 'px'},
        {'color':_vm.configData.titleColor.color[0].item}
     ])},[_vm._v("\n        "+_vm._s(_vm.configData.listConfig.list[0].info[0].value)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }